<template>

    <div class="button-toolbar" :class="classes">
        <slot></slot>
    </div>

</template>

<style scoped lang="scss">

    .button-toolbar {
        align-items: center;
        display: flex;
        flex-shrink: 0;
        &.size-sm {
            > * {
                margin-left: 5px !important;
                &:first-child {
                    margin-left: 0 !important;
                }
            }
        }
        &.size-md {
            > * {
                margin-left: 10px !important;
                &:first-child {
                    margin-left: 0 !important;
                }
            }
        }
    }

</style>

<script>

export default {

    props: {
        size: {
            type: String,
            default: 'sm',
        },
    },

    computed: {

        classes() {
            return {
                'size-sm': this.size === 'sm',
                'size-md': this.size === 'md',
            };
        },

    },

}

</script>
